var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArtisan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-22"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "483.6 33.23 483.6 168.92 288.72 168.92 281.7 34.18 483.6 33.23",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.92,
    y: 3.97,
    width: 134.45,
    height: 194.88,
    transform: "translate(277.73 480.55) rotate(-90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.5,169.56H280.78V33.26H477.5Zm-194.87-1.85h193V35.11h-193Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.81,
    y: 50.89,
    width: 152.66,
    height: 101.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.47,50.89l-.75,0-2.17,0-8.38.05-31.46.12-109.9.22.44-.44c0,30.87,0,65.07,0,101h0l-.48-.48,152.66.09-.38.39c.08-30.75.15-56,.2-73.52,0-8.77.08-15.63.1-20.33,0-2.32,0-4.1,0-5.34s0-1.85,0-1.85,0,.59,0,1.77,0,3,.05,5.27c0,4.68.05,11.51.1,20.24,0,17.62.11,42.91.2,73.76v.38h-.39l-152.66.1h-.48v-.48h0c0-36,0-70.16,0-101v-.45h.44L413,50.66l31.37.12,8.29.06,2.12,0C455.25,50.87,455.47,50.89,455.47,50.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.7,33.81c.08-.11,1.36.73,3.35,2.17s4.71,3.48,7.64,5.82S298.2,46.37,300,48a16,16,0,0,1,2.79,2.86c-.18.2-4.87-3.66-10.72-8.34S281.53,34,281.7,33.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.58,34.18c.16.21-4.43,4.12-10.25,8.73s-10.69,8.19-10.86,8,4.43-4.12,10.26-8.73S476.41,34,476.58,34.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.43,168.65,454.7,151",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.7,151c.16-.21,5.16,3.57,11.16,8.43s10.73,9,10.57,9.18-5.17-3.57-11.17-8.43S454.53,151.25,454.7,151Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.7,168.63c-.16-.21,4.38-4.07,10.15-8.64s10.58-8.09,10.74-7.88-4.37,4.08-10.14,8.64S281.87,168.84,281.7,168.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.92,
    y: 51.25,
    width: 33.83,
    height: 96.06,
    transform: "translate(282.55 481.12) rotate(-90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565.68,
    y: 200.15,
    width: 131.62,
    height: 248.8,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526.62,
    y: 200.15,
    width: 131.62,
    height: 248.8,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.55,251.37h-113V211.93h113ZM537,250h110.2V213.32H537Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.39,212.62h42.87a0,0,0,0,1,0,0v2.91a4.95,4.95,0,0,1-4.95,4.95h-33a4.95,4.95,0,0,1-4.95-4.95v-2.91A0,0,0,0,1,571.39,212.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.55,301.46h-113V262h113ZM537,300.07h110.2V263.41H537Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.39,262.72h42.87a0,0,0,0,1,0,0v2.91a4.95,4.95,0,0,1-4.95,4.95h-33a4.95,4.95,0,0,1-4.95-4.95v-2.91A0,0,0,0,1,571.39,262.72Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.55,351.56h-113V312.12h113ZM537,350.17h110.2V313.51H537Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.39,312.81h42.87a0,0,0,0,1,0,0v2.91a4.95,4.95,0,0,1-4.95,4.95h-33a4.95,4.95,0,0,1-4.95-4.95v-2.91A0,0,0,0,1,571.39,312.81Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.55,401.66h-113V362.22h113ZM537,400.27h110.2V363.61H537Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.39,362.91h42.87a0,0,0,0,1,0,0v2.91a4.95,4.95,0,0,1-4.95,4.95h-33a4.95,4.95,0,0,1-4.95-4.95v-2.91A0,0,0,0,1,571.39,362.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520.78,
    y: 190.84,
    width: 142.96,
    height: 12.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 663.74,
    y: 190.84,
    width: 42.99,
    height: 12.39,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526.62,
    y: 448.95,
    width: 6.92,
    height: 12.71,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 569.35,
    y: 448.95,
    width: 6.92,
    height: 12.71,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.42,
    y: 448.95,
    width: 6.92,
    height: 12.71,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.45,
    y: 448.95,
    width: 6.92,
    height: 12.71,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "648.48 157.76 661.8 191.84 653.52 191.8 646.88 170.86 648.48 157.76",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "602.98 126.26 598.4 191.57 645.68 192.56 651 126.26 602.98 126.26",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "607.71 131.52 603.9 185.88 639.05 187.53 643.96 131.2 607.71 131.52",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "615.43 139.21 612.58 177.42 631.96 177.42 635.38 139.21 615.43 139.21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.86,
    y: 311.45,
    width: 200.94,
    height: 92.67,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,399.76H69.46V316.33H261ZM70.71,398.51H259.77V317.58H70.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.8,
    y: 311.45,
    width: 49.09,
    height: 92.67,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.09,342.15h190.3a.26.26,0,0,0,0-.51H70.09a.26.26,0,0,0,0,.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.86,341.9a209.44,209.44,0,0,0,.07-25.18.26.26,0,0,0-.52,0,209.44,209.44,0,0,0,.07,25.18.19.19,0,0,0,.38,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.09,329.31a2.6,2.6,0,1,1-2.6-2.59A2.59,2.59,0,0,1,217.09,329.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.21,329.31a2.59,2.59,0,1,1-2.59-2.59A2.59,2.59,0,0,1,117.21,329.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165.24,
    cy: 358.04,
    r: 2.59,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.89 404.12 78.54 462.3 84.36 462.3 103.44 404.12 88.89 404.12",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.59 404.12 260.24 462.4 254.42 462.4 237.04 404.12 251.59 404.12",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.43 404.12 300.23 462.4 294.41 462.4 275.88 404.12 290.43 404.12",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.66,384.27a2.6,2.6,0,1,1-2.59-2.59A2.59,2.59,0,0,1,167.66,384.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.09,370.84h190.3a.25.25,0,0,0,0-.5H70.09a.25.25,0,0,0,0,.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.67,311.41s-.17,0-.49-.09-.81-.16-1.45-.24a39.33,39.33,0,0,0-5.62-.2c-1.23,0-2.59,0-4.09-.12a15.43,15.43,0,0,1-4.75-1.08,8.83,8.83,0,0,1-4.24-3.62,6.73,6.73,0,0,1-.92-3A4.78,4.78,0,0,1,205,300a5.48,5.48,0,0,1,2.79-2,3.85,3.85,0,0,1,3.51.58,4.66,4.66,0,0,1,1.66,3.32,6.1,6.1,0,0,1-1,3.74,10.91,10.91,0,0,1-2.76,2.87,15.66,15.66,0,0,1-3.58,2,17.09,17.09,0,0,1-8.43,1.1,15.76,15.76,0,0,1-8.22-3.44,17.11,17.11,0,0,1-5.27-7.66,16.21,16.21,0,0,1-.34-9.61,12.67,12.67,0,0,1,2.28-4.44,8.88,8.88,0,0,1,4.13-2.93,8.11,8.11,0,0,1,5.06,0,6.09,6.09,0,0,1,3.72,3.32,7.55,7.55,0,0,1,.34,4.91,8.72,8.72,0,0,1-2.4,4.22,13,13,0,0,1-8.69,3.18A23.08,23.08,0,0,1,179,297.5,31.87,31.87,0,0,1,166,287.59,42,42,0,0,1,159.12,275a69.72,69.72,0,0,1-2.87-11.49c-.57-3.44-.89-6.43-1.12-8.87s-.38-4.33-.47-5.62c0-.63-.07-1.11-.1-1.47s0-.5,0-.5,0,.17.07.5.08.83.14,1.46c.14,1.31.32,3.19.57,5.61s.61,5.42,1.21,8.84a69.85,69.85,0,0,0,2.93,11.41,41.31,41.31,0,0,0,6.84,12.44,31.5,31.5,0,0,0,12.88,9.73,22.46,22.46,0,0,0,8.61,1.57,12.48,12.48,0,0,0,8.35-3.05,8.26,8.26,0,0,0,2.25-4,7.06,7.06,0,0,0-.31-4.58,5.59,5.59,0,0,0-3.41-3,7.61,7.61,0,0,0-4.74,0,8.36,8.36,0,0,0-3.89,2.75,12.14,12.14,0,0,0-2.18,4.26,15.63,15.63,0,0,0,.32,9.31,16.78,16.78,0,0,0,5.1,7.44,15.29,15.29,0,0,0,8,3.34,16.52,16.52,0,0,0,8.2-1.05,13,13,0,0,0,6.14-4.67,5.63,5.63,0,0,0,1-3.47,4.25,4.25,0,0,0-1.49-3.05,3.48,3.48,0,0,0-3.16-.52,5.07,5.07,0,0,0-2.59,1.84,4.44,4.44,0,0,0-.85,2.9,6.25,6.25,0,0,0,.86,2.81,8.56,8.56,0,0,0,4.06,3.53,15.71,15.71,0,0,0,4.67,1.1c1.47.14,2.83.14,4.06.15a36.64,36.64,0,0,1,5.64.31A10.4,10.4,0,0,1,225.67,311.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.73 247.54 113.85 311.52 120.29 311.52 136.77 247.54 129.73 247.54",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.77 247.54 191.65 311.52 185.21 311.52 168.73 247.54 175.77 247.54",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.24,
    y: 230.15,
    width: 7.49,
    height: 81.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.97,
    y: 164.89,
    width: 105.67,
    height: 67.7,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.31,
    y: 246.51,
    width: 53.04,
    height: 6.54,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,223.75a7.93,7.93,0,0,1,.07,1.24h-.14c-.11-3.31-.19-14.28-.19-27.28,0-7.84.06-14.94.08-20.16,0-2.53.06-4.6.08-6.11,0-.68,0-1.23,0-1.67a1.92,1.92,0,0,1,0-.57,2.49,2.49,0,0,1,.05.57c0,.44,0,1,0,1.67,0,1.51,0,3.58.08,6.11,0,5.22,0,12.32.08,20.16,0,13-.08,24-.19,27.28h-.14A6.57,6.57,0,0,1,106,223.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.85,223.75a7,7,0,0,1,.08,1.24h-.15c-.11-3.31-.19-14.28-.19-27.28,0-7.84.06-14.94.08-20.16,0-2.53.06-4.6.08-6.11,0-.68,0-1.23,0-1.67a3.54,3.54,0,0,1,0-.57,2.09,2.09,0,0,1,.06.57c0,.44,0,1,0,1.67,0,1.51,0,3.58.08,6.11,0,5.22,0,12.32.07,20.16,0,13-.08,24-.18,27.28h-.15A7.93,7.93,0,0,1,113.85,223.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.72,223.75a7.93,7.93,0,0,1,.07,1.24h-.14c-.11-3.31-.19-14.28-.19-27.28,0-7.84.05-14.94.07-20.16,0-2.53.07-4.6.09-6.11,0-.68,0-1.23,0-1.67a1.92,1.92,0,0,1,0-.57,2.49,2.49,0,0,1,0,.57c0,.44,0,1,0,1.67,0,1.51.05,3.58.08,6.11,0,5.22,0,12.32.08,20.16,0,13-.08,24-.19,27.28h-.14A6.57,6.57,0,0,1,121.72,223.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.58,223.75a6.57,6.57,0,0,1,.07,1.24h-.14c-.11-3.31-.19-14.28-.19-27.28,0-7.84.06-14.94.08-20.16,0-2.53.06-4.6.08-6.11,0-.68,0-1.23.05-1.67a2.49,2.49,0,0,1,.05-.57,2.09,2.09,0,0,1,.06.57c0,.44,0,1,0,1.67,0,1.51,0,3.58.09,6.11,0,5.22,0,12.32.07,20.16,0,13-.08,24-.19,27.28h-.14A7.93,7.93,0,0,1,129.58,223.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.45,223.75a7.93,7.93,0,0,1,.07,1.24h-.15c-.1-3.31-.18-14.28-.18-27.28,0-7.84.05-14.94.07-20.16,0-2.53.07-4.6.09-6.11,0-.68,0-1.23,0-1.67a2.09,2.09,0,0,1,.06-.57,3.54,3.54,0,0,1,.05.57c0,.44,0,1,.05,1.67,0,1.51,0,3.58.08,6.11,0,5.22.05,12.32.08,20.16,0,13-.08,24-.19,27.28h-.15A7,7,0,0,1,137.45,223.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.31,223.75a6.57,6.57,0,0,1,.07,1.24h-.14c-.11-3.31-.19-14.28-.19-27.28,0-7.84.06-14.94.08-20.16,0-2.53.06-4.6.08-6.11,0-.68,0-1.23,0-1.67a2.49,2.49,0,0,1,.05-.57,1.92,1.92,0,0,1,.05.57c0,.44,0,1,0,1.67,0,1.51.05,3.58.09,6.11,0,5.22,0,12.32.07,20.16,0,13-.08,24-.19,27.28h-.14A7.93,7.93,0,0,1,145.31,223.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.18,223.75a7.93,7.93,0,0,1,.07,1.24h-.15c-.11-3.31-.18-14.28-.18-27.28,0-7.84.05-14.94.07-20.16,0-2.53.06-4.6.08-6.11,0-.68,0-1.23.05-1.67a2.09,2.09,0,0,1,.06-.57,3.54,3.54,0,0,1,0,.57c0,.44,0,1,.05,1.67,0,1.51.05,3.58.08,6.11,0,5.22,0,12.32.08,20.16,0,13-.08,24-.19,27.28h-.15A7,7,0,0,1,153.18,223.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,223.75a6.57,6.57,0,0,1,.07,1.24H161c-.11-3.31-.19-14.28-.19-27.28,0-7.84.06-14.94.08-20.16,0-2.53.06-4.6.08-6.11,0-.68,0-1.23.05-1.67a1.92,1.92,0,0,1,0-.57,1.92,1.92,0,0,1,.05.57c0,.44,0,1,0,1.67,0,1.51.05,3.58.08,6.11,0,5.22.05,12.32.08,20.16,0,13-.08,24-.19,27.28H161A6.57,6.57,0,0,1,161,223.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.9,223.75A7,7,0,0,1,169,225h-.15c-.11-3.31-.19-14.28-.19-27.28,0-7.84.06-14.94.08-20.16,0-2.53.06-4.6.08-6.11,0-.68,0-1.23,0-1.67a3.54,3.54,0,0,1,.05-.57,2.09,2.09,0,0,1,.06.57c0,.44,0,1,0,1.67,0,1.51,0,3.58.08,6.11,0,5.22,0,12.32.07,20.16,0,13-.07,24-.18,27.28h-.15A10,10,0,0,1,168.9,223.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.77,223.75a7.93,7.93,0,0,1,.07,1.24h-.14c-.11-3.31-.19-14.28-.19-27.28,0-7.84.05-14.94.07-20.16,0-2.53.07-4.6.09-6.11,0-.68,0-1.23.05-1.67a1.92,1.92,0,0,1,.05-.57,2.49,2.49,0,0,1,0,.57c0,.44,0,1,.05,1.67,0,1.51,0,3.58.08,6.11,0,5.22.05,12.32.08,20.16,0,13-.08,24-.19,27.28h-.14A6.57,6.57,0,0,1,176.77,223.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.63,223.75a7,7,0,0,1,.08,1.24h-.15c-.11-3.31-.19-14.28-.19-27.28,0-7.84.06-14.94.08-20.16,0-2.53.06-4.6.08-6.11,0-.68,0-1.23.05-1.67a3.54,3.54,0,0,1,0-.57,2.09,2.09,0,0,1,.06.57c0,.44,0,1,0,1.67,0,1.51.05,3.58.09,6.11,0,5.22,0,12.32.07,20.16,0,13-.08,24-.18,27.28h-.15A7.93,7.93,0,0,1,184.63,223.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.5,223.75a7.93,7.93,0,0,1,.07,1.24h-.14c-.11-3.31-.19-14.28-.19-27.28,0-7.84,0-14.94.07-20.16,0-2.53.07-4.6.09-6.11,0-.68,0-1.23,0-1.67a1.92,1.92,0,0,1,.05-.57,2.49,2.49,0,0,1,.05.57c0,.44,0,1,0,1.67,0,1.51.05,3.58.08,6.11,0,5.22,0,12.32.08,20.16,0,13-.08,24-.19,27.28h-.14A6.57,6.57,0,0,1,192.5,223.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.36,223.75a6.57,6.57,0,0,1,.07,1.24h-.14c-.11-3.31-.19-14.28-.19-27.28,0-7.84.06-14.94.08-20.16,0-2.53.06-4.6.08-6.11,0-.68,0-1.23.05-1.67a2.49,2.49,0,0,1,.05-.57,1.92,1.92,0,0,1,0,.57c0,.44,0,1,.05,1.67,0,1.51,0,3.58.09,6.11,0,5.22,0,12.32.07,20.16,0,13-.08,24-.19,27.28h-.14A7.93,7.93,0,0,1,200.36,223.75Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M691.34,462.47c0,.15-146.18.26-326.46.26s-326.49-.11-326.49-.26,146.15-.26,326.49-.26S691.34,462.33,691.34,462.47Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.88,200.73c-4.39-.44-8.1-3.48-10.87-6.92s-4.86-7.39-7.75-10.72c-2.16-2.48-2.5-7.52-5.69-8.33-4-1-5.94-6.72-5.68-10,.28-3.56,3.17-7.15,3.08-8.22-.24-2.8-3.45-4.81-3.5-7.62-.12-6.61,5-7.52,5-7.52,1.27-3.43,3-8,7.41-10.93,4.76-3.19,12.13-6.89,17.75-5.77s9.68,1.75,13,6.42",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.45,198.46l-4.39,22.66-9.86,20.41-13.15-9.11-4.34-12.29-3.64-10.3s-14.36,2.89-19.53-10.63c-2.5-6.52-6.54-20.38-10.06-33a27,27,0,0,1,16.64-32.56l1.31-.48c14.43-4.38,26.22,5.42,30.2,20l16.82,45.3",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,174.94a2.08,2.08,0,0,0,2.6,1.27,2,2,0,0,0,1.35-2.49,2.06,2.06,0,0,0-2.59-1.26A2,2,0,0,0,389,174.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.38,171.16c.33.16,1.4-1.47,3.49-2.23s4-.28,4.13-.62c.07-.16-.34-.52-1.19-.76a5.69,5.69,0,0,0-3.42.18,5.42,5.42,0,0,0-2.66,2.09C386.27,170.55,386.22,171.09,386.38,171.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.56,167.59a2.07,2.07,0,0,0,2.59,1.27,2,2,0,0,0,1.36-2.49,2.08,2.08,0,0,0-2.59-1.27A2,2,0,0,0,408.56,167.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,162.91c.32.2,1.56-1.31,3.72-1.84s4,.15,4.17-.17c.09-.14-.28-.55-1.1-.88a5.66,5.66,0,0,0-3.42-.19,5.48,5.48,0,0,0-2.88,1.79C406.91,162.29,406.8,162.82,407,162.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.63,182.89a14.67,14.67,0,0,0-3.62.64c-.55.14-1.1.22-1.32-.11a2.86,2.86,0,0,1-.23-1.71c0-1.47.06-3,.09-4.64.06-6.58-.11-11.91-.38-11.91s-.53,5.33-.58,11.91c0,1.62,0,3.17,0,4.64a3.33,3.33,0,0,0,.49,2.2,1.42,1.42,0,0,0,1.17.45,3.83,3.83,0,0,0,.95-.21A14.42,14.42,0,0,0,405.63,182.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.3,182.07c-.35.11.48,2.37-.86,4.7s-3.85,3-3.75,3.28c0,.15.7.24,1.72-.1a6,6,0,0,0,3.18-2.62,5.2,5.2,0,0,0,.58-3.88C412.91,182.47,412.45,182,412.3,182.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.68,155.94c.37.53,2.43-.34,5-.73s4.82-.26,5-.88c.08-.29-.42-.74-1.4-1.08a8.82,8.82,0,0,0-7.65,1.23C404.85,155.11,404.51,155.69,404.68,155.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.38,165.47c.55.34,1.8-.68,3.52-1.34s3.31-.86,3.47-1.48c.05-.29-.35-.68-1.16-.89a5.45,5.45,0,0,0-5.62,2.27C385.16,164.74,385.14,165.3,385.38,165.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.27,130.5A11,11,0,0,1,401.63,145c-2.46.38-5.4.1-7,2s-.63,5.22-1.93,7.49c-1.86,3.25-6.85,2.56-9.89,4.74-2.34,1.69-3.1,4.76-4.1,7.46s-2.9,5.62-5.79,5.75a32.85,32.85,0,0,1-1.4-7.33,11,11,0,0,1,2-7.06c.83-1.08,1.94-1.95,2.66-3.11,1.56-2.51,1-5.73,1.48-8.65a12,12,0,0,1,6.64-8.74c2.87-1.34,6.24-1.52,8.89-3.26,1.95-1.29,3.34-3.34,5.36-4.51,3.95-2.28,8.94-.62,13.06,1.33",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.83,141.24c1.71-1.2,5.16-3.78,5.6-5.78,1-4.34,4-8.14,8.06-9.31a10.13,10.13,0,0,1,11.25,4.55,14.57,14.57,0,0,1,14.47,3.48,16.86,16.86,0,0,1,4.75,15c-.27,1.39-.72,2.83-.27,4.2.56,1.69,2.27,2.59,3.64,3.67,3.72,3,5.36,8.23,4.95,13s-1.21,6.69-3.55,8.44c-4.6,3.42,5.27,11.53-3.31,14.53l-13.58-29.67a3.59,3.59,0,0,1-.7.58c-4.68,2.92-8.81-6.77-8.67-10a31.48,31.48,0,0,1-7-3.58c-2.13-1.58-5.33-6.8-5.92-9.45C406.78,141.62,398.09,141.77,398.83,141.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.2,163.78c.19-.19,8.31-6.2,11.43,3.19s-6.95,10.6-7.05,10.33S430.2,163.78,430.2,163.78Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.26,172.79s.2.06.52.09a1.66,1.66,0,0,0,1.23-.38c.88-.69,1.19-2.55.67-4.25a5.58,5.58,0,0,0-1.24-2.19,2,2,0,0,0-1.65-.85.87.87,0,0,0-.81.77c0,.3.08.47,0,.5s-.26-.09-.31-.5a1.11,1.11,0,0,1,.17-.71,1.33,1.33,0,0,1,.83-.54,2.42,2.42,0,0,1,2.19.89,5.83,5.83,0,0,1,1.44,2.43c.57,1.91.19,4-1,4.85a1.88,1.88,0,0,1-1.58.25C436.35,173,436.24,172.82,436.26,172.79Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.05,209.83a33.69,33.69,0,0,0,15.85-11.56s-.58,11.32-14.58,15.09Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.68,141a56.5,56.5,0,0,0,15.09,1c8.35-.57,9.5-5.19,12.2-9.58a14.19,14.19,0,0,1,6.75,9.67s-4.72,13.43-21.25,11.82C421.47,153.91,409.42,150.57,408.68,141Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.35,152.81c.25.22-.37,1.5-2.1,2.95a14.34,14.34,0,0,1-16.61,1c-1.89-1.23-2.65-2.43-2.43-2.68s1.39.35,3.27,1a17.39,17.39,0,0,0,14.75-.87C441,153.32,442.07,152.54,442.35,152.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.83,159.77c.14,0-.23,1.22-1.39,2.13a3.11,3.11,0,0,1-2.39.85c0-.15,1-.44,2.07-1.26S419.7,159.71,419.83,159.77Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.58,162.37a5.24,5.24,0,0,1-2.2.79,5.41,5.41,0,0,1-2.32.29,10.63,10.63,0,0,1,4.52-1.08Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.09,158.43c0,.08-.32.22-.82.51s-1.18.74-2,1.21a6.3,6.3,0,0,1-2.22.87c-.62.09-1,0-1-.08s.37-.11.92-.28a9.45,9.45,0,0,0,2-1,13.71,13.71,0,0,1,2.08-1.09C401.68,158.39,402.07,158.37,402.09,158.43Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.1,152.84c0,.08-.62.27-1.49.87a20.2,20.2,0,0,0-3,2.8,11.46,11.46,0,0,1-3.35,2.61,2.94,2.94,0,0,1-1.73.37c0-.09.65-.19,1.56-.7a14.48,14.48,0,0,0,3.15-2.64,14.23,14.23,0,0,1,3.22-2.75A3,3,0,0,1,405.1,152.84Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.58,175c.07.12-.63.58-1.63.62s-1.73-.35-1.68-.47.78,0,1.66-.05S388.52,174.83,388.58,175Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.94,176.09c.05.13-.4.44-.79,1s-.57,1-.72,1-.18-.69.31-1.33S387.9,176,387.94,176.09Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.36,182.16c-.13.06-.53-.6-1.36-.95s-1.58-.2-1.63-.34.15-.21.49-.28a2.17,2.17,0,0,1,1.34.14,2.25,2.25,0,0,1,1,.88C415.41,181.91,415.42,182.14,415.36,182.16Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.29,182.38c-.15.05-.49-.69-1.21-1.32s-1.49-.92-1.45-1.06,1-.09,1.79.67S417.42,182.36,417.29,182.38Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.65,167.24a4.15,4.15,0,0,1-1.64,2.49,4,4,0,0,1-2.73,1.2c0-.14,1.2-.57,2.39-1.6S416.51,167.17,416.65,167.24Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.92,408.73l1.36,34.42s-34.54,12.94-34.9,19.32l66.83-.22.09-53.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.93,440.19a2.71,2.71,0,0,1,1.9,3.1,2.62,2.62,0,0,1-3.06,1.91,2.88,2.88,0,0,1-2-3.3c.44-1.27,2.23-2.26,3.41-1.63",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.21,462.25l-.2-5.42-64,2.24s-3,1.31-2.62,3.4Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M399.19,442.81c0,.33,1.65.47,3.26,1.52s2.46,2.41,2.76,2.28-.19-2-2.16-3.24S399.12,442.52,399.19,442.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.19,445.74c-.07.31,1.34.86,2.46,2.24s1.44,2.84,1.76,2.82.53-1.86-.89-3.55S392.2,445.43,392.19,445.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.24,454.14c.3.07.74-1.56-.1-3.35s-2.37-2.49-2.51-2.22.81,1.23,1.48,2.71S387.91,454.11,388.24,454.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.75,434.94c.14.29,1.64-.16,3.48,0s3.29.69,3.46.41-1.22-1.44-3.4-1.55S399.59,434.68,399.75,434.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.55,453.74l34.07-5.1s16.62,32.92,23,32.59l-7.52-66.41-53.4,5.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.42,428.43a2.72,2.72,0,0,1,2.88-2.22,2.63,2.63,0,0,1,2.23,2.84,2.88,2.88,0,0,1-3.06,2.34c-1.31-.3-2.49-2-2-3.21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M629.12,414.82l-5.37.79L633,479s1.62,2.81,3.67,2.24Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M613.4,449.76c.32-.05.29-1.69,1.15-3.4s2.13-2.72,2-3-2,.41-3,2.5S613.11,449.86,613.4,449.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.07,456.4c.32,0,.72-1.43,2-2.69s2.66-1.74,2.61-2.06-1.9-.32-3.42,1.27S616.76,456.42,617.07,456.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.85,459.41c0-.3-1.63-.57-3.31.46s-2.22,2.63-1.93,2.74,1.13-.94,2.52-1.77S625.86,459.74,625.85,459.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.51,450.06c.28-.17-.34-1.61-.42-3.46s.33-3.34,0-3.47-1.3,1.36-1.17,3.54S605.27,450.25,605.51,450.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.84 268.25 411.8 279.79 397.11 309.5 354.36 285.27 363.84 268.25",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.64,260.94l-8.2-1.57-11.25,5.3-4.77,10.6a3.74,3.74,0,0,0,.72,4.13c2,2.12,5.35,5.33,7.07,5.6,0,0,.25,3.72,3.75,3.9,0,0-1,1.72,3.05,2.37s16.84-1.72,16.84-1.72.75-2.23-2.74-5l4.17-3.36s-.25-2.66-4.15-3.33l4.18-6.86Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.41 285.43 365.46 293.96 376.92 270.83 359.3 264.39 348.69 284.94 351.41 285.43",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.54 266.16 328.61 268.65 299.32 257.62 295.69 256.68 294.05 255.28 295.23 253.04 297.17 253.28 300.33 255.3 329.54 266.16",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.11,284.59a10.53,10.53,0,0,1-2.42,1.11,52.35,52.35,0,0,1-6.14,1.94,53.4,53.4,0,0,1-6.33,1.18,12.31,12.31,0,0,1-2.66.16,16,16,0,0,1,2.61-.53c1.61-.28,3.83-.71,6.25-1.32s4.58-1.27,6.14-1.77A16.55,16.55,0,0,1,352.11,284.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.11,284.55a83.88,83.88,0,0,0,16.95-4,8,8,0,0,0,2-.93,3.08,3.08,0,0,0,1.29-1.84",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.38,277.79a1.53,1.53,0,0,1-.23.86,3.79,3.79,0,0,1-1.78,1.6A57.76,57.76,0,0,1,343,282.7a70.93,70.93,0,0,1-7.63,1.57,17.37,17.37,0,0,1-3.22.28,24.71,24.71,0,0,1,3.16-.65c2-.37,4.63-.93,7.55-1.71s5.57-1.58,7.39-2.27a4,4,0,0,0,1.77-1.38C352.27,278.09,352.33,277.78,352.38,277.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.83,280.73l-25.92-9.64,2.69-7.24,25.92,9.64a3.86,3.86,0,0,1,2.27,5h0A3.85,3.85,0,0,1,353.83,280.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.06,276.17A108.91,108.91,0,0,1,348.78,274a4.07,4.07,0,0,1,2.29.41,2.8,2.8,0,0,1,1.16,2.15v0A3.69,3.69,0,0,1,350,280l-.06,0",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.92,280.06s.35-.21.9-.69a3.37,3.37,0,0,0,1.24-2.61,2.92,2.92,0,0,0-.73-1.84,2.74,2.74,0,0,0-2.12-.68c-1.73,0-3.66.11-5.66.25-4,.27-7.64.71-10.25,1.1l-3.09.46a4.69,4.69,0,0,1-1.15.12,5.89,5.89,0,0,1,1.11-.32c.72-.17,1.77-.39,3.07-.63A95.18,95.18,0,0,1,343.51,274c2-.14,3.94-.2,5.7-.2a3.15,3.15,0,0,1,2.44.86,3.28,3.28,0,0,1,.78,2.12,3.12,3.12,0,0,1-.54,1.77,3.89,3.89,0,0,1-.95,1C350.34,280,349.92,280.1,349.92,280.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.53,268.86s-8.25-7.33-11.52-9.14a11.34,11.34,0,0,0-8.05-1.45c-1.83.45-15.43,10.28-15.43,10.28s1.33,3.19,5.84,2.73a11.54,11.54,0,0,0,7-3.17s.85,4.47,6.43,5.9C355.21,275.66,364.53,268.86,364.53,268.86Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.24,259.91a5.74,5.74,0,0,1-.92.73l-2.65,1.92-9.28,6.5.05-.35a6.49,6.49,0,0,0,2.69,1.94,7.2,7.2,0,0,0,3.53.33,13.93,13.93,0,0,0,6.53-3.05l.28-.23.11.34a9,9,0,0,0,8.22,6.16,9.64,9.64,0,0,0,3.14-.41,10.62,10.62,0,0,1,1.1-.36,1.34,1.34,0,0,1-.26.16,6,6,0,0,1-.79.35,8.93,8.93,0,0,1-3.2.56,9,9,0,0,1-4.76-1.38,9.47,9.47,0,0,1-3.92-4.93l.39.11a14,14,0,0,1-6.77,3.19,7.54,7.54,0,0,1-3.78-.36,6.79,6.79,0,0,1-2.9-2.11l-.17-.21.23-.15c3.75-2.55,7-4.74,9.39-6.36l2.73-1.8A5.59,5.59,0,0,1,342.24,259.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.3,289.86a2.3,2.3,0,0,0-.09-3.08,6.8,6.8,0,0,0-2.91-1.69,4.11,4.11,0,0,0,1.84-1.16,2.35,2.35,0,0,0,.67-1.36,2.23,2.23,0,0,0-1.28-2,5.38,5.38,0,0,0-2.2-.34",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.33,280.23a1.92,1.92,0,0,1,.6-.06,3.19,3.19,0,0,1,1.67.23,2.43,2.43,0,0,1,1.45,2.09,2.38,2.38,0,0,1-.58,1.45,4.37,4.37,0,0,1-1.25,1,3.8,3.8,0,0,1-.84.36v-.49a8.49,8.49,0,0,1,2.44,1.24A3,3,0,0,1,355,288a2.1,2.1,0,0,1-.28,1.47c-.2.3-.38.39-.4.37a2.31,2.31,0,0,0,.34-1.78,2.72,2.72,0,0,0-1.1-1.62,8.71,8.71,0,0,0-2.33-1.12l-.72-.26.73-.23a4.35,4.35,0,0,0,.74-.32,2.87,2.87,0,0,0,1.61-2,2.11,2.11,0,0,0-1.14-1.75,3.57,3.57,0,0,0-1.51-.36C350.53,280.33,350.32,280.27,350.33,280.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.87 268.25 358.7 289.86 362.81 292.35 373.31 269.51 369.87 268.25",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.53,210.13s4.49-14,12.9-15.12,18.39-.76,25.21,1.73c12.3,4.5,63.73,58.88,63.73,58.88S538,276.75,532.82,285l-43.29,16.39H453S426.46,266.62,427,265.75,420.53,210.13,420.53,210.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.61,352.34s1.27,87.14,4.23,94.33,6.77,12.69,19.46,15.23,107.87-4.23,107.87-4.23L601.52,415l-67.82-6.22s-.29-19.16.13-28.05,10.35-25.52,11.61-45.38S474.61,352.34,474.61,352.34Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.36,408c0,.08-1.23.64-3.15,1.72a43.63,43.63,0,0,0-7,5,43.09,43.09,0,0,0-5.88,6.31c-1.33,1.76-2,2.93-2.13,2.89a3.54,3.54,0,0,1,.42-.88,26,26,0,0,1,1.42-2.23,35.85,35.85,0,0,1,5.82-6.48,36.26,36.26,0,0,1,7.21-4.9,25.7,25.7,0,0,1,2.4-1.1A3.93,3.93,0,0,1,535.36,408Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.47,433.26a4.62,4.62,0,0,1,.15-1.07c.12-.67.34-1.65.66-2.84a59.41,59.41,0,0,1,3.26-9.07,58.81,58.81,0,0,1,4.71-8.41c.69-1,1.28-1.82,1.71-2.36a4.39,4.39,0,0,1,.71-.81c.06.05-.82,1.29-2.12,3.38A73.64,73.64,0,0,0,528,420.5a75.5,75.5,0,0,0-3.39,8.95C523.92,431.8,523.55,433.28,523.47,433.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M475.05,370.84l-.05.36a38.75,38.75,0,0,0,25.59,8,43.79,43.79,0,0,0,26.12-11.56C510.51,372.25,491.85,372.06,475.05,370.84Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "577 412.7 579.51 459.43 594.27 458.48 591.47 414.03 577 412.7",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.22,273.41l53.45,25.66,43.2-19.94s8.08,9.55,9.66,13.52,2.11,17.52,2.11,17.52l-55.58,7.22H442.11l-8.68-14.73Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.05,301.41c-5.08-5.92-73.82,6.51-73.82,6.51s-68.11,3-78.26,4.66-19.66,19.34-19.66,29.91,9.1,90.77,9.1,90.77L440,427.4c-.42-7.61-6.39-62.37-6.39-62.37s52.87,9.31,66.41,7.61,36-16.92,41-24.11S550.12,307.33,545.05,301.41Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.46,309.5s83.64-10.83,109.83,9c0,0,4.89-11.29-2.24-17.06s-110.54,3.1-110.54,3.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.69,345.49a5.67,5.67,0,0,1,1.2.21,10.76,10.76,0,0,1,1.38.37,18.29,18.29,0,0,1,1.8.61,28,28,0,0,1,4.42,2.18,29.23,29.23,0,0,1,8.78,8.23,27.19,27.19,0,0,1,2.45,4.28c.32.63.52,1.23.73,1.75a11.16,11.16,0,0,1,.45,1.35,4.71,4.71,0,0,1,.28,1.19c-.1,0-.56-1.64-1.79-4.13a30.18,30.18,0,0,0-2.52-4.16,32.9,32.9,0,0,0-3.92-4.48,33.56,33.56,0,0,0-4.71-3.62,31.22,31.22,0,0,0-4.31-2.25C414.37,346,412.67,345.59,412.69,345.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.79,354.38a3.39,3.39,0,0,1,.88.11A23.88,23.88,0,0,1,417,355a39.46,39.46,0,0,1,7.38,2.95,38.35,38.35,0,0,1,6.63,4.38c.78.65,1.39,1.2,1.79,1.61s.62.63.59.66-1-.76-2.61-2a49,49,0,0,0-6.64-4.21,48.3,48.3,0,0,0-7.25-3.05C415,354.77,413.77,354.46,413.79,354.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.87,367.76l-.24.07-.7.16-2.71.57c-1.18.25-2.62.54-4.31.8s-3.6.62-5.74.86l-3.35.41c-1.16.14-2.38.22-3.64.34-2.52.27-5.22.38-8.06.54-5.68.22-11.94.23-18.5-.08a289.24,289.24,0,0,1-33.38-3.78c-4.24-.72-7.66-1.35-10-1.83l-2.71-.56-.71-.16c-.16,0-.24-.06-.23-.07l.24,0,.71.11,2.73.46c2.37.42,5.8,1,10,1.67a316.4,316.4,0,0,0,33.34,3.62c6.55.31,12.79.31,18.46.12,2.83-.14,5.53-.24,8-.49,1.26-.11,2.47-.18,3.64-.31l3.35-.38c2.13-.21,4-.54,5.74-.78s3.13-.49,4.31-.71l2.73-.47.71-.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.16,353.44a4.11,4.11,0,0,1-.67.25l-1.95.61-7.17,2.14-.19.06-.06-.2c-1.36-5-2.66-11.76-4-19.15-1-5.62-2.09-10.86-3.19-15.2l-.07-.27h.27a50.16,50.16,0,0,1,10.34.76c1.23.22,2.18.44,2.83.6a5.33,5.33,0,0,1,1,.3,7.54,7.54,0,0,1-1-.16c-.65-.13-1.61-.31-2.84-.49a56.21,56.21,0,0,0-10.28-.57l.21-.28c1.15,4.35,2.22,9.59,3.27,15.21,1.37,7.4,2.62,14.16,3.9,19.15l-.24-.14,7.22-2,2-.51A3.32,3.32,0,0,1,460.16,353.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.69,352.71a4.65,4.65,0,0,1-.1-1.15c0-.85-.07-1.89-.12-3.13a96.72,96.72,0,0,0-3.11-20.38l-.81-3a5.06,5.06,0,0,1-.26-1.13,4.28,4.28,0,0,1,.45,1.07c.26.69.6,1.72,1,3a77.14,77.14,0,0,1,3.12,20.47c0,1.33,0,2.4,0,3.14A5.55,5.55,0,0,1,461.69,352.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M450.46,356.39c-2.32-10.18-3.89-19.56-6.21-29.74l-.12-.11c1.28,11.67,2.33,23.34,3.62,35a34.84,34.84,0,0,0,11.73-8Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M423.87,370.72a3,3,0,0,1,.16.7c.08.52.19,1.19.32,2,.26,1.82.63,4.33,1.08,7.4l0,.2-.2,0c-5.14.62-12,.93-19.53,1.22-5.71.23-11,.5-15.5,1l-.27,0,0-.27a49.76,49.76,0,0,1,2.25-10.12c.39-1.19.75-2.1,1-2.72a5.81,5.81,0,0,1,.43-.92,6.61,6.61,0,0,1-.31,1c-.21.63-.53,1.56-.89,2.75A56.26,56.26,0,0,0,390.42,383l-.24-.24c4.46-.51,9.8-.81,15.52-1,7.52-.29,14.38-.55,19.51-1.09l-.17.22c-.38-3.08-.69-5.6-.91-7.43-.09-.83-.16-1.5-.22-2A5.35,5.35,0,0,1,423.87,370.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.38,369.1a4.34,4.34,0,0,1-1.15-.08l-3.12-.33a97.8,97.8,0,0,0-20.62.13l-3.11.37a5.49,5.49,0,0,1-1.15.09,4.35,4.35,0,0,1,1.11-.29c.73-.16,1.79-.35,3.1-.54a78.39,78.39,0,0,1,10.35-.76,76.13,76.13,0,0,1,10.36.64c1.32.17,2.38.35,3.11.49A5.66,5.66,0,0,1,423.38,369.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M425.39,380.74c-10.4.82-24.78,1.46-35.19,2.28l4,2.66c11.73.42,34.28-1.38,34.28-1.38l-4.6-12.89Q424.66,376.07,425.39,380.74Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M506.25,272.35a7.33,7.33,0,0,1-.78,1c-.53.66-1.32,1.59-2.32,2.72-2,2.25-4.86,5.28-8.24,8.4s-6.63,5.73-9,7.54c-1.21.9-2.2,1.62-2.9,2.09a6.21,6.21,0,0,1-1.11.69,7.17,7.17,0,0,1,1-.86l2.79-2.21c2.35-1.88,5.54-4.53,8.91-7.64s6.27-6.07,8.33-8.26l2.43-2.6A5.56,5.56,0,0,1,506.25,272.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.28,271.61a17.28,17.28,0,0,1-.46,3.09c-.37,1.89-.95,4.48-1.74,7.32s-1.63,5.36-2.29,7.16a17.63,17.63,0,0,1-1.2,2.88,19.46,19.46,0,0,1,.85-3c.57-1.84,1.35-4.37,2.14-7.19s1.42-5.4,1.88-7.26A21.72,21.72,0,0,1,482.28,271.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.41,305.59l-1.66,44.71a13.7,13.7,0,0,0,13.14,14.19l20.05.8a13.68,13.68,0,0,0,14.2-12.63c1.1-14.32,2.08-36.59-1.22-47.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.35,309.43a10,10,0,0,1-1.7.29c-1.09.16-2.68.34-4.65.51A124.16,124.16,0,0,1,512.19,309c-2-.33-3.52-.64-4.6-.89a10.73,10.73,0,0,1-1.66-.43,10.32,10.32,0,0,1,1.7.23c1.09.19,2.67.44,4.62.73A151.43,151.43,0,0,0,527.58,310a149.55,149.55,0,0,0,15.39-.17c2-.12,3.56-.24,4.66-.34A12.17,12.17,0,0,1,549.35,309.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.54,327.11a8,8,0,0,1-1.51.65c-.49.2-1.1.43-1.82.65s-1.53.52-2.45.75a55.88,55.88,0,0,1-6.52,1.41,61.34,61.34,0,0,1-8.15.67,63,63,0,0,1-8.16-.49,56.76,56.76,0,0,1-6.55-1.26c-.92-.21-1.74-.48-2.46-.7s-1.34-.42-1.84-.61a11,11,0,0,1-1.53-.61,9.21,9.21,0,0,1,1.59.42c.51.16,1.13.34,1.86.52s1.54.43,2.47.62a63.94,63.94,0,0,0,6.52,1.15,62,62,0,0,0,16.18-.18,62.48,62.48,0,0,0,6.49-1.29c.93-.21,1.74-.47,2.46-.67s1.34-.4,1.84-.57A12.28,12.28,0,0,1,549.54,327.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.44,295.57a7.25,7.25,0,0,1-1.11.71c-.73.44-1.81,1-3.18,1.66A55.76,55.76,0,0,1,459,301.82a56.34,56.34,0,0,1-11.74,1.43c-1.52,0-2.75,0-3.59-.09a6.25,6.25,0,0,1-1.31-.16,7.3,7.3,0,0,1,1.32-.05c.84,0,2.06,0,3.57-.07a64.55,64.55,0,0,0,11.63-1.56A65.86,65.86,0,0,0,470,297.61c1.38-.61,2.48-1.13,3.23-1.51A6.49,6.49,0,0,1,474.44,295.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.76,427.4c-.06-.53-1.57-14.19-1.57-14.19L438.14,408l1.31,13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "530.71 338.3 524.48 347.84 528.53 347.84 525.79 356.19 533.62 345.36 529.44 345.36 530.71 338.3",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.47,245.69s-11.64,19.54-11.66,31.81l-55.13,26.85,5.87,16.12s65.48-7.8,69.93-10.18,16.12-12,19.41-19.43,8.52-29.81,8.52-29.81Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.31,279.93c-.05.07-.75-.43-2-1a17.51,17.51,0,0,0-5.08-1.59,17.23,17.23,0,0,0-5.32,0c-1.35.23-2.17.5-2.19.42a6.08,6.08,0,0,1,2.12-.78,14.94,14.94,0,0,1,5.47-.2,14.67,14.67,0,0,1,5.17,1.79A5.91,5.91,0,0,1,417.31,279.93Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.51 297.76 292.39 313.41 335.3 322.51 334.56 303.18 306.51 297.76",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.64,303.18s-8.24-2-12.21-1.62-21.94,4.36-21.94,4.36-1.38,3.24,3.11,4.62,10.54,0,10.54,0-11.06,8.81-11.23,9.5-1.55,2.25.17,3.46,6.91,0,6.91,0,0,3.8,1.56,4.83,2.93,1.9,2.93,1.9,2.77,2.94,4.49,3.46,5.19,1.21,5.19,1.21h5.18l14-11.83,12.06-2.6-7.68-23.35Z",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.45,320.92a12.24,12.24,0,0,1-4,1.82,12.6,12.6,0,0,1-4.35.84,35.31,35.31,0,0,1,4.19-1.33A38.34,38.34,0,0,1,332.45,320.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.73,310.93a48.26,48.26,0,0,1,.2,6.33,50.51,50.51,0,0,1-.09,6.33,53.62,53.62,0,0,1-.11-12.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.85 300.3 362.24 322.01 367.27 320.92 358.7 298.51 354.85 300.3",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.22,199s-16.73,4.38-20,11.79-13.58,43.7-13.58,43.7l44.79,15.81s5.76-25.78,8.23-35.65S469.85,205.85,440.22,199Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.62,254.49a.88.88,0,0,1,.25,0l.7.22,2.67.88,9.81,3.32,32.41,11.17-.34.2c0-.26.09-.55.14-.84,2.2-13.41,4.19-25.55,5.65-34.39.74-4.36,1.34-7.91,1.77-10.41.21-1.19.38-2.14.51-2.83l.14-.73a1.23,1.23,0,0,1,.07-.25,1,1,0,0,1,0,.26c0,.2-.05.44-.09.74-.1.69-.24,1.64-.41,2.84-.39,2.51-.94,6.07-1.61,10.44-1.41,8.85-3.36,21-5.5,34.42,0,.28-.09.57-.14.83l-.05.31-.29-.1L419.93,259.3l-9.76-3.47-2.64-1-.68-.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463,226.16a3.61,3.61,0,0,1-.05.9c-.06.57-.19,1.39-.37,2.41a57.83,57.83,0,0,1-5.12,15.19c-.46.92-.86,1.65-1.16,2.14s-.47.76-.5.74a30,30,0,0,1,1.33-3c.84-1.86,1.93-4.47,2.92-7.43s1.71-5.69,2.17-7.68A29.05,29.05,0,0,1,463,226.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.44,255.54a1.66,1.66,0,0,1-.16.41l-.54,1.16c-.47,1-1.16,2.48-1.93,4.37a52.07,52.07,0,0,0-3.75,16v.14l-.13.06-10.12,4.89c-8.53,4.18-16.23,8-21.84,10.66-2.8,1.35-5.09,2.41-6.67,3.13l-1.83.82a3.13,3.13,0,0,1-.65.25,2.85,2.85,0,0,1,.61-.35l1.79-.9,6.59-3.28,21.77-10.79c3.56-1.74,7-3.39,10.14-4.87l-.14.2a50.14,50.14,0,0,1,4-16.12c.81-1.88,1.55-3.34,2.06-4.33l.61-1.12A2,2,0,0,1,409.44,255.54Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.17 232.59 428.94 242.12 432.99 242.12 430.25 250.47 438.08 239.64 433.9 239.64 435.17 232.59",
    style: {
      fill: "#132D8C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.84,256.17a74.73,74.73,0,0,1-8.3-2.6,72.5,72.5,0,0,1-8.12-3.1,75,75,0,0,1,8.29,2.6A72.23,72.23,0,0,1,437.84,256.17Z",
    style: {
      fill: "#132D8C"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtisan);
export default __webpack_public_path__ + "static/media/artisan.155fce4a6481d1974c9d34589bd4a76f.svg";
export { ForwardRef as ReactComponent };